module.exports = __webpack_public_path__ + "img/b5-1.c2555f5.png";